import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Plus, Map, Sun, Search } from 'lucide-react';
import DashboardCard from './DashboardCard';

const QuickActions = () => {
  const actions = [
    {
      label: "Find Sunny Spots",
      icon: <Sun className="h-4 w-4" />,
      href: "/list?filter=sunny",
      variant: "default" as const,
      description: "View currently sunny terraces"
    },
    {
      label: "View Map",
      icon: <Map className="h-4 w-4" />,
      href: "/",
      variant: "outline" as const,
      description: "Explore all terraces on map"
    },
    {
      label: "Submit Terrace",
      icon: <Plus className="h-4 w-4" />,
      href: "/submit",
      variant: "outline" as const,
      description: "Add a new terrace"
    },
    {
      label: "Browse All",
      icon: <Search className="h-4 w-4" />,
      href: "/list",
      variant: "outline" as const,
      description: "See all terraces"
    }
  ];

  return (
    <DashboardCard
      title="Quick Actions"
      description="Jump to your most common tasks"
      icon={<Sun className="h-5 w-5" />}
      variant="highlight"
    >
      <div className="grid grid-cols-2 gap-3">
        {actions.map((action, index) => (
          <Button
            key={index}
            asChild
            variant={action.variant}
            className="h-auto p-3 flex flex-col items-center space-y-1"
          >
            <Link to={action.href}>
              {action.icon}
              <span className="text-xs font-medium text-center leading-tight">
                {action.label}
              </span>
            </Link>
          </Button>
        ))}
      </div>
    </DashboardCard>
  );
};

export default QuickActions;